import { format } from "date-fns";
import { fr } from "date-fns/locale";
import { Card, CardContent } from "@/components/ui/card";
import { DiscrepancyStatus } from "./DiscrepancyStatus";
import { DiscrepancyActions } from "./DiscrepancyActions";
import { DiscrepancyCardProps } from "@/types/discrepancy";
export const DiscrepancyItem = ({
  discrepancy,
  onStatusUpdate,
  onJustifiedClick
}: DiscrepancyCardProps) => {
  return <Card>
      <CardContent className="p-4 sm:p-6 bg-slate-300 hover:bg-slate-200">
        <div className="flex flex-col sm:flex-row justify-between items-start gap-4">
          <div className="space-y-1 w-full sm:w-auto">
            <div className="font-medium">
              Méthode de paiement: {discrepancy.payment_method}
            </div>
            <div className="text-sm text-gray-500">
              Date: {format(new Date(discrepancy.counting_date), "dd MMMM yyyy", {
              locale: fr
            })}
            </div>
          </div>
          <DiscrepancyStatus status={discrepancy.status} />
        </div>

        <div className="mt-4 space-y-2">
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 text-sm">
            <div>
              <span className="text-gray-500">Montant attendu:</span>
              <div>{discrepancy.expected_amount.toLocaleString()} FCFA</div>
            </div>
            <div>
              <span className="text-gray-500">Montant compté:</span>
              <div>{discrepancy.counted_amount.toLocaleString()} FCFA</div>
            </div>
            <div>
              <span className="text-red-700">Différence:</span>
              <div>{discrepancy.difference_amount.toLocaleString()} FCFA</div>
            </div>
          </div>

          {discrepancy.explanation && <div className="text-sm">
              <span className="text-gray-500">Explication:</span>
              <div className="mt-1 break-words">{discrepancy.explanation}</div>
            </div>}
        </div>

        <div className="mt-4">
          <DiscrepancyActions discrepancy={discrepancy} onStatusUpdate={onStatusUpdate} onJustifiedClick={onJustifiedClick} />
        </div>
      </CardContent>
    </Card>;
};